import { FormControl } from '@angular/forms';
import Computer from 'mbs-ui-shared@models/Computer';

export interface VirtualDiskFileFormat {
  Name: string;
  VariantName: string;
  DisplayName: string;
  UseBuilder: boolean;
}

export enum RestoreTypeFromAgentEnum {
  PhysicalDisk = 1,
  VirtualDisk = 2,
  File = 4,
  FilesFromDiskImage = 8,
  RestoreToEC2 = 16,
  RestoreToAzure = 32,
  RestoreToGCE = 64,
  RestoreToVMware = 128,
  RestoreToHyperV = 256,
  RestoreToEC2FileLevel = 512,
  RestoreToProxmox = 1024
}

export enum EC2RestoreTypeEnum {
  EC2Instance = 0,
  EC2Image = 1,
  EC2Volume = 2
}

export enum AzureRestoreTypeEnum {
  AzureInstance = 0,
  AzureDataDisk = 1
}

export enum RestoreAsDiskEnum {
  Physical = 0,
  Virtual = 1,
  EC2 = 2,
  EBSVolume = 3,
  AVM = 4,
  ADD = 5,
  RestoreToVMware = 6,
  RestoreToHyperV = 7,
  RestoreToHyperVAndImport = 8,
  RestoreToProxmox = 9,
  RestoreToVMwareVSphere = 10,
  InstantRestoreToHyperV = 11,
  InstantRestoreToProxmox = 12,
  InstantRestoreToDRServer = 13
}

export interface TypeDataStepValueForm {
  restoreAs: FormControl<RestoreAsDiskEnum>;
  createAMI?: FormControl<boolean>;
  drServerComputer: FormControl<Computer>;
  selectedFileFormat: FormControl<string>;
}

export interface TypeDataStepValue {
  restoreAs: RestoreAsDiskEnum;
  createAMI?: boolean;
  drServerComputer?: Computer;
  selectedFileFormat: string;
  valid: boolean;
}

// The value the agent stores in TestVmSettings.TestType for an instant restore plan
export enum RestoreTestType {
  HyperV = 'LocalHyperV',
  Proxmox = 'Proxmox',
  DRServer = 'DRServer'
}

export const RestoreTestTypeToRestoreAs: Partial<Record<string, RestoreAsDiskEnum>> = {
  [RestoreTestType.HyperV]: RestoreAsDiskEnum.InstantRestoreToHyperV,
  [RestoreTestType.Proxmox]: RestoreAsDiskEnum.InstantRestoreToProxmox,
  [RestoreTestType.DRServer]: RestoreAsDiskEnum.InstantRestoreToDRServer
};

export const CloudRestoreTypes = [RestoreAsDiskEnum.EC2, RestoreAsDiskEnum.AVM];
export const InstantRestoreTypes = [
  RestoreAsDiskEnum.InstantRestoreToHyperV,
  RestoreAsDiskEnum.InstantRestoreToProxmox,
  RestoreAsDiskEnum.InstantRestoreToDRServer
];
export const RestoreToHyperVTypes = [
  RestoreAsDiskEnum.RestoreToHyperV,
  RestoreAsDiskEnum.RestoreToHyperVAndImport,
  RestoreAsDiskEnum.InstantRestoreToHyperV
];
export const RestoreToVMNeedHostTypes = [
  RestoreAsDiskEnum.RestoreToVMwareVSphere,
  RestoreAsDiskEnum.RestoreToProxmox,
  RestoreAsDiskEnum.InstantRestoreToProxmox
];
export const RestoreToVMTypes = [
  RestoreAsDiskEnum.RestoreToVMwareVSphere,
  RestoreAsDiskEnum.RestoreToProxmox,
  RestoreAsDiskEnum.RestoreToHyperV,
  RestoreAsDiskEnum.RestoreToHyperVAndImport,
  RestoreAsDiskEnum.InstantRestoreToProxmox,
  RestoreAsDiskEnum.InstantRestoreToHyperV
];
